import ParenthesesLogo from '~/assets/drill/parentheses'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function Parentheses({
  title,
  completed,
  path,
}: {
  title: string
  completed: boolean
  path: string
}): React.ReactElement {
  const gridMobile = 'row-start-11 row-end-13 col-start-2 col-end-4'
  const gridTablet = 'md:row-start-3 md:row-end-3 md:col-start-1 md:col-end-3'
  const gridDesktop = 'xl:row-start-2 xl:row-end-2 xl:col-start-4 xl:col-end-6'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={ParenthesesLogo}
      imageClassNames="h-10"
      path={path}
      title={title}
    />
  )
}
